export default {
  isAdmin: () => {
    return (window.gon && window.gon.current_user && window.gon.current_user_role_names.includes('admin'));
  },
  isContentEditor: () => {
    return (window.gon && window.gon.current_user && window.gon.current_user_role_names.includes('content_editor'));
  },
  isHomeInspector: () => {
    return (window.gon && window.gon.current_user && window.gon.current_user_role_names.includes('home_inspector'));
  }
};